import React, { useEffect, useState } from "react"

import { BellRinging, X } from "@phosphor-icons/react"
import { Dialog, DialogPanel } from "@headlessui/react"
import InputField from "@components/common/InputField"
import { getShopifyImage } from "gatsby-source-shopify"
import { GatsbyImage } from "gatsby-plugin-image"

const NotifyMeModal = ({ productName, notifySizes = [], isOpen = false, onClose = () => {}}) => {
    const [email, setEmail] = useState('')
    const [sizeSelected, setSizeSelected] = useState([])

    const handleClose = () => {
        setSizeSelected([])
        onClose()
    }

    const handleSizeSelected = (item) => {
        setSizeSelected((prev) => {
            if (prev.some((curr) => curr.title === item.title)) {
                return prev.filter((curr) => curr.title !== item.title)
            } else {
                return [...prev, { ...item, isActive: true }]
            }
        })
    }

    const handleSendMeNotification = () => {

    }

    const filename = productName?.[1]?.replace("FINAL SALE", "")?.replace(" ", "-")?.toLowerCase()?.trim();
    
    const colorData = {
        originalSrc: `https://cdn.shopify.com/s/files/1/1219/5720/files/${filename}.png`,
        width: 48,
        height: 48,
    };

    const gatsbyColorImage = getShopifyImage({
        image: colorData ?? colorData,
        layout: "constrained",
        crop: "contain",
        width: 48,
        height: 48,
    })

    const openState = isOpen || false;
    
    return (
        <React.Fragment>
            <Dialog open={openState} onClose={handleClose} className="relative z-50">
                <div className="fixed inset-0 w-screen overflow-y-auto p-4 bg-black bg-opacity-60">
                    <div className="flex min-h-full items-center justify-center">
                        <DialogPanel className="relative border bg-white p-6 w-128 overflow-y-auto minimalist-scrollbar gap-6">
                            <X
                                className="absolute top-0 right-0 cursor-pointer text-black m-4"
                                size={32}
                                weight="light"
                                onClick={handleClose}
                            />

                            <section className="">
                                <div className="flex flex-1 gap-2 items-center">
                                    <div>
                                        <GatsbyImage
                                            className={`border-2 border-black opacity-50 circle-8`}
                                            style={{overflow: "hidden", width: "48px", height: "48px", borderRadius: "50%"}}
                                            objectFit="contain"
                                            loading="lazy"
                                            alt={`${productName?.[1]?.replace("FINAL SALE", "")}`}
                                            image={gatsbyColorImage ?? gatsbyColorImage}
                                        />
                                    </div>
                                    <div>
                                        <h1 className="leading-normal text-[20px] mr-10">{productName?.[0]?.replace("FINAL SALE", "")}</h1>
                                        <h4>{productName?.[1]?.replace("FINAL SALE", "")}</h4>
                                    </div>
                                </div>

                                <div className="text-xs space-x-2 text-primary pt-10">
                                    <span className="font-semibold">NOTIFY FOR:</span>
                                    <span>{sizeSelected?.map((item, index) => `${item?.title}${index !== sizeSelected.length - 1 ? ', ' : ''}`)}</span>
                                </div>

                                <div className="flex flex-nowrap gap-x-2 py-8">
                                    {notifySizes?.map((item, index) => (
                                        <button
                                            key={index}
                                            className={`${sizeSelected?.find(curr => curr?.title === item?.title)?.isActive ? 'text-white bg-black' : 'text-black bg-white'} relative py-2 px-4 border border-black w-[120px]`}
                                            onClick={() => handleSizeSelected(item)}
                                            aria-label={item?.title}
                                        >
                                            {item?.title}
                                        </button>
                                    ))}
                                </div>

                                <div className="space-y-2 text-xs">
                                    <InputField
                                        id="email"
                                        label="YOUR EMAIL ADDRESS"
                                        placeholder="johndoe@example.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        labelOnTop
                                    />
                                    <h4>Be the first to receive stock updates for this product.</h4>
                                </div>
                            </section>

                            <div className="w-full flex pt-8">
                                <button 
                                    className='w-full btn-primary text-primary flex gap-2 justify-center items-center'
                                    onClick={() => handleSendMeNotification()}
                                >
                                    <BellRinging size={20} weight='light' />
                                    <span>Notify me when available</span>
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    );
}

export default NotifyMeModal